var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTestimonialsSection = function SvgTestimonialsSection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 199 89"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#6C8A8E",
    transform: "translate(-10.5 -6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M119.903 46.601A14.45 14.45 0 0 0 124 36.5c0-8.008-6.492-14.5-14.5-14.5S95 28.492 95 36.5c0 4.38 1.943 8.308 5.014 10.967.224-4.27 3.126-7.829 7.057-9.031a5.5 5.5 0 1 1 5.191-.179 10.01 10.01 0 0 1 7.641 8.344",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 2,
    x: 70,
    y: 54.467,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 2,
    x: 70,
    y: 61.467,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 5,
    x: 83,
    y: 68.467,
    rx: 2.5
  }))));
};
export { SvgTestimonialsSection as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTk5IDg5IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyB0cmFuc2Zvcm09J3RyYW5zbGF0ZSgtMTAuNSAtNi41KSc+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMTkuOTAzIDQ2LjYwMUMxMjIuNDM5IDQzLjk4OTkgMTI0IDQwLjQyNzMgMTI0IDM2LjVDMTI0IDI4LjQ5MTkgMTE3LjUwOCAyMiAxMDkuNSAyMkMxMDEuNDkyIDIyIDk1IDI4LjQ5MTkgOTUgMzYuNUM5NSA0MC44ODA5IDk2Ljk0MjkgNDQuODA4MSAxMDAuMDE0IDQ3LjQ2NjlDMTAwLjIzOCA0My4xOTc5IDEwMy4xNCAzOS42MzgzIDEwNy4wNzEgMzguNDM1OUMxMDUuMjUyIDM3LjUzODggMTA0IDM1LjY2NTYgMTA0IDMzLjVDMTA0IDMwLjQ2MjQgMTA2LjQ2MiAyOCAxMDkuNSAyOEMxMTIuNTM4IDI4IDExNSAzMC40NjI0IDExNSAzMy41QzExNSAzNS41MzA3IDExMy45IDM3LjMwNDMgMTEyLjI2MiAzOC4yNTdDMTE2LjI1MiAzOS4xNzk3IDExOS4zMjcgNDIuNDg5NiAxMTkuOTAzIDQ2LjYwMVoiIGZpbGw9IiM2QzhBOEUiLz4KICA8cmVjdCB4PSI3MCIgeT0iNTQuNDY2OCIgd2lkdGg9Ijc5IiBoZWlnaHQ9IjIiIHJ4PSIxIiBmaWxsPSIjNkM4QThFIi8+CiAgPHJlY3QgeD0iNzAiIHk9IjYxLjQ2NjgiIHdpZHRoPSI3OSIgaGVpZ2h0PSIyIiByeD0iMSIgZmlsbD0iIzZDOEE4RSIvPgogIDxyZWN0IHg9IjgzIiB5PSI2OC40NjY4IiB3aWR0aD0iNTMiIGhlaWdodD0iNSIgcng9IjIuNSIgZmlsbD0iIzZDOEE4RSIvPgo8L2c+Cjwvc3ZnPgo=";